import { useTranslation } from 'react-i18next'

import { SEARCH_RESULTS_INHABITANTS_ENTITY } from '../../../constants/entity'
import { INHABITANT_STATUS } from '../../../constants/inhabitant'
import { ROUTE_PATH_LIST } from '../../../constants/route'
import { InhabitantTableLayout, useInhabitantTablePage } from '../../Inhabitant'
import { useSearchResultsTableOptions } from '../SearchResults.hooks'
import { getSearchResultsBreadcrumbs } from '../SearchResults.utils'
import { SearchResultsPage } from '../SearchResultsPage'

import { updateSearchResultsInhabitantsTableConfig } from './SearchResultsInhabitants.api'
import {
  QA_NAME_SEARCH_RESULTS_INHABITANTS_TABLE,
  SEARCH_RESULTS_INHABITANTS_CONFIG_API,
  SEARCH_RESULTS_INHABITANTS_LIST_API,
} from './SearchResultsInhabitants.constants'

import UserIcon from '../../../icons/user.svg'

function SearchResultsInhabitants() {
  const { t } = useTranslation()

  const { asyncTableOptions, extraSelectionResetDeps, searchQuery } =
    useSearchResultsTableOptions({
      asyncTableOptions: {
        listApi: SEARCH_RESULTS_INHABITANTS_LIST_API,
        tableConfigApi: SEARCH_RESULTS_INHABITANTS_CONFIG_API,
      },
    })

  const tablePage = useInhabitantTablePage({
    asyncTableOptions,
    entity: SEARCH_RESULTS_INHABITANTS_ENTITY,
    extraSelectionResetDeps,
    pageTitle: t('SearchResults.InhabitantsBrowserTabTitleKey'),
    onApplyTableConfig: updateSearchResultsInhabitantsTableConfig,
  })

  const breadcrumbs = getSearchResultsBreadcrumbs({
    leadingBreadcrumbs: [
      {
        id: 'inhabitants',
        title: t('BrowserTab.InhabitantsPageTitleKey'),
        to: `/${ROUTE_PATH_LIST.inhabitants}/`,
      },
    ],
    searchQuery,
    t,
  })

  return (
    <SearchResultsPage
      EntityIcon={UserIcon}
      TableLayout={InhabitantTableLayout}
      breadcrumbs={breadcrumbs}
      emptyText={t('InhabitantTable.NoDataKey')}
      layoutProps={{
        rowStatuses: INHABITANT_STATUS,
        skeletonProps: { withCheckbox: false },
      }}
      qaName={QA_NAME_SEARCH_RESULTS_INHABITANTS_TABLE}
      tablePage={tablePage}
    />
  )
}

export default SearchResultsInhabitants
